import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { TrendingUp, Package, ShoppingBag, DollarSign } from "lucide-react";
import api from "@/lib/api";
import { formatKWD } from "@/lib/format";

function Stat({ icon: Icon, label, value, testid, onClick }) {
  return (
    <div onClick={onClick} data-testid={testid}
      className={`bg-white border border-border p-5 ${onClick ? "cursor-pointer hover:border-primary hover:shadow-sm transition-all" : ""}`}>
      <div className="flex items-center gap-2 text-text-muted text-xs mb-3">
        <Icon className="w-4 h-4" strokeWidth={1.5} /> {label}
      </div>
      <div className="text-2xl font-medium">{value}</div>
    </div>
  );
}

const PAY_LABEL = { cash: "نقداً", knet: "كي نت" };

export default function Dashboard() {
  const [d, setD] = useState(null);
  const nav = useNavigate();
  useEffect(() => { api.get("/admin/dashboard").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <div className="p-8 text-text-muted">…</div>;

  return (
    <div className="p-5 md:p-8">
      <h1 className="font-display text-3xl mb-6">لوحة التحكم</h1>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <Stat icon={TrendingUp} label="قيمة المبيعات" value={formatKWD(d.sales_value)} testid="stat-sales" onClick={() => nav("/admin/reports")} />
        <Stat icon={Package} label="القطع المباعة" value={d.units_sold} testid="stat-units" onClick={() => nav("/admin/reports")} />
        <Stat icon={ShoppingBag} label="الموديلات المتاحة" value={d.active_products} testid="stat-products" onClick={() => nav("/admin/products")} />
        <Stat icon={DollarSign} label="عدد الفواتير" value={d.invoice_count} testid="stat-invoices" onClick={() => nav("/admin/invoices")} />
      </div>

      <div className="bg-white border border-border p-5 max-w-xl">
        <h2 className="text-sm tracking-luxe uppercase text-accent mb-4">المبيعات حسب طريقة الدفع</h2>
        {Object.keys(d.by_method).length === 0 ? (
          <p className="text-text-muted text-sm">لا توجد مبيعات بعد</p>
        ) : (
          <div className="space-y-2">
            {Object.entries(d.by_method).map(([m, v]) => (
              <div key={m} className="flex justify-between text-sm border-b border-border pb-2">
                <span>{PAY_LABEL[m] || m}</span><span>{formatKWD(v)}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

